module.exports = __webpack_public_path__ + "officialStatic/img/soft26.6e386a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/soft26.png
// module id = LTz3
// module chunks = 0